import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Preloader } from '@/components/Preloader';
import { useGetRepaymentScheduleByFundraisingId } from '@/query/queries/loan/useGetRepaymentScheduleByFundraisingId';
import { RepScheduleTable } from '../../RepaymentScheduleModule/table';
import s from './index.module.scss';

export const RepaymentSchedule = ({ fundraisingID, group }) => {
  const { t } = useTranslation('loans');
  const { data, isLoading } = useGetRepaymentScheduleByFundraisingId(
    fundraisingID,
    group,
  );

  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <h2 className="f-article-accent">{t('loan_info.repayment_schedule')}</h2>
        {!!data?.list.length && data?.show_extend_disclaimer && (
          <div className={classnames(s.disclaimer, 'f-small-regular')}>
            {t('loan_info.repayment_schedule_disclaimer')}
          </div>
        )}
      </div>

      {isLoading ? (
        <Preloader style={{ height: '150px' }} />
      ) : data?.list.length ? (
        <RepScheduleTable data={data.list} />
      ) : (
        <div className={classnames(s.empty_message, 'f-small-regular')}>
          {t('loan_info.no_repayments')}
        </div>
      )}
    </div>
  );
};
